import React, { useState } from "react";
import * as moment from "moment";
import Button from "web/components/Button";
import DatePicker from "web/components/DatePicker";
import DropDown from "web/components/DropDown";
import { BIDFORMAT } from "web/components/utils/dateOfBirthValidation";
import styled from "styled-components";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup";

export default ({ isOpen, toggle, callBackFun }) => {
  let toDate = new Date();
  let fromDate = new Date();
  fromDate.setDate(fromDate.getDate() - 31);
  toDate.setDate(toDate.getDate() + 31);

  const INITIAL_VALUES = {
    filterByDelivery: "ALL",
    filterByStatus: "ALL",
    fromDate: fromDate.toISOString().substring(0, 10),
    toDate: toDate.toISOString().substring(0, 10),
  };

  const VALIDATION_SCHEMA = Yup.object().shape({});

  const [bidStatuses, setBidStatuses] = useState([
    { label: "All", value: "ALL" },
    { label: "Offer Placed", value: "PENDING" },
    { label: "Withdrawn", value: "WITHDRAW" },
    { label: "Declined", value: "REJECTED" },
    { label: "Accepted", value: "ACCEPTED" },
  ]);

  const [filterOptions, setFilterOptions] = useState([
    { label: "All", value: "ALL" },
    { label: "Pickup", value: "PICKUP" },
    { label: "Delivery", value: "DELIVERY" },
  ]);

  return (
    <div className="alert-modal">
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={VALIDATION_SCHEMA}
        onSubmit={(values) => { }}
      >
        {(props) => {
          const { isValid, dirty, values, errors, touched, setFieldValue, resetForm, } = props;

          return (
            <>
              <Form>
                <Modal isOpen={isOpen} centered={true} size="md">
                  <ModalHeader toggle={() => toggle()}>
                    <h6>Filter by</h6>
                  </ModalHeader>
                  <ModalBody>
                    <InventoryFilterModelBody>
                      <DropDownWrapper>
                        <div className="dropDown">
                          <label>Offer Status</label>
                          <DropDown
                            name="filterByStatus"
                            data={bidStatuses}
                            placeholder=""
                            searchDropDown={props.values.filterByStatus}
                            onChangeHandler={(event) => {
                              setFieldValue("filterByStatus", event.value);
                            }}
                          />
                        </div>
                        <div className="dropDown">
                          <label>Delivery Requirements</label>
                          <DropDown
                            name="filterByDelivery"
                            data={filterOptions}
                            placeholder=""
                            searchDropDown={props.values.filterByDelivery}
                            onChangeHandler={(event) => {
                              setFieldValue("filterByDelivery", event.value);
                            }}
                          />
                        </div>
                      </DropDownWrapper>
                      <SelectWrapper>
                        <label>Requested Date</label>
                        <div>
                          <DatePicker name="fromDate" maxDate={props.values?.toDate} value={props.values?.fromDate}
                            callBackFun={(date) => {
                              setFieldValue("fromDate", moment(date).format(BIDFORMAT));
                            }} />
                          <p style={{ 'margin-top': '5px' }}>To</p>
                          <DatePicker name="toDate" minDate={props.values?.fromDate} value={props.values?.toDate}
                            callBackFun={(date) => {
                              setFieldValue("toDate", moment(date).format(BIDFORMAT));
                            }} />
                        </div>
                      </SelectWrapper>
                    </InventoryFilterModelBody>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      type="app-green-button"
                      handleClick={() => {
                        callBackFun(props.values);
                        toggle();
                      }}
                    >
                      Apply Filter
                    </Button>
                  </ModalFooter>
                </Modal>
              </Form>
            </>
          );
        }}
      </Formik>
    </div>
  );
};

const DropDownWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  .dropDown {
    div {
      p {
        margin: 12px;
      }
    }
  }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 18px;
  }
`;

const SelectWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  > div {
    display: flex;
    p {
      margin: 12px;
    }
  }
  .dropDown {
    width: 200px;
  }
  select,
  input {
    // padding: 5px;
    // border: solid 1px transparent !important;
    // margin: 2px 0;
    // font-size: 16px;
    // padding: 10px 13px 10px 13px;
    // border-radius: 5px;
    // background-color: #e8e2e2;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #656565;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #656565;
    }

    ::placeholder {
      color: #656565;
    }
  }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 18px;
  }
  @media (max-width: 650px) {
    > div {
      flex-direction: column;
    }
  }
`;

const InventoryFilterModelBody = styled.div`
  padding-bottom: 20px;
`;
